import { createBuilderModule } from '../../../register-builder/builder-module';
import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { TableSection } from './TableSection';
import { DEFAULT_VALUES } from './fixtures';

export default createBuilderModule(
  withTracking(TableSection, {
    as: 'section',
    sectionName: SectionName.TableSection,
  }),
  {
    name: 'TableSection',
    image: 'https://cdn.zappy.app/05373ef2b4f09243f922a398b0fdc981.png',
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
      {
        name: 'headers',
        type: 'list',
        subFields: [{ name: 'text', type: 'string' }],
        defaultValue: DEFAULT_VALUES.headers,
      },
      {
        name: 'rows',
        type: 'list',
        defaultValue: DEFAULT_VALUES.rows,
        subFields: [
          {
            name: 'cells',
            type: 'list',
            subFields: [
              { name: 'text', type: 'richText' },
              { name: 'rowSpan', type: 'number' },
              { name: 'columnSpan', type: 'number' },
            ],
          },
        ],
      },
      {
        name: 'sectionSpacing',
        type: 'string',
        enum: ['0', '20px', '40px', '60px', '80px'],
        defaultValue: DEFAULT_VALUES.sectionSpacing,
      },
      {
        name: 'titleTag',
        type: 'string',
        enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        defaultValue: DEFAULT_VALUES.titleElement,
      },
      {
        name: 'titleSize',
        type: 'string',
        enum: ['small', 'medium', 'large'],
        defaultValue: DEFAULT_VALUES.titleSize,
      },
      {
        name: 'titleAlignment',
        type: 'string',
        enum: ['center', 'left'],
        defaultValue: DEFAULT_VALUES.titleAlignment,
      },
      {
        name: 'scrollableOnMobile',
        type: 'boolean',
        defaultValue: DEFAULT_VALUES.scrollableOnMobile,
        helperText:
          'Whether the table should be horizontally scrollable on mobile or ' +
          'should be constrained to the width of the screen',
      },
    ],
  },
);
